import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function AITaskActionNode({ id, data }) {
    return (
        <NodeComponent title="AI Task" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

